import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authApi } from '../services/api'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [message, setMessage] = useState({ type: '', text: '' })

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim()) {
      setMessage({ type: 'error', text: 'Por favor ingresa tu correo' })
      return
    }
    setSubmitting(true)
    setMessage({ type: '', text: '' })
    try {
      await authApi.forgotPassword(email.trim().toLowerCase())
      setMessage({
        type: 'success',
        text: 'Si el correo existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña.',
      })
    } catch {
      setMessage({ type: 'error', text: 'Ocurrió un error. Intenta de nuevo más tarde.' })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-cream-100">
      <div className="max-w-md w-full space-y-6 p-8 bg-cream-50 rounded-lg shadow-md">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-terracotta-700">☕ Cafe Distribution</h1>
          <p className="mt-2 text-espresso-600">Recuperar Contraseña</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-espresso-700 mb-1">
              Correo Electrónico
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@ejemplo.com"
              className="w-full px-3 py-2 border border-espresso-200 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500 focus:border-terracotta-500"
              autoFocus
            />
          </div>
          {message.type && (
            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-700'}`}>
              {message.text}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-terracotta-600 hover:bg-terracotta-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta-500 disabled:opacity-50"
          >
            {submitting ? 'Enviando...' : 'Enviar Enlace de Recuperación'}
          </button>
        </form>
        <div className="text-center">
          <Link to="/login/admin" className="text-sm text-terracotta-700 hover:text-terracotta-800">
            Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  )
}
